import React from "react";
import "../../App.css";

const Header = ({ currentStep = 1 }) => {
  const steps = [
    { id: 1, label: "Consent Collection" },
    { id: 2, label: "Aadhaar Authentication" },
    { id: 3, label: "Communication Details" },
    { id: 4, label: "ABHA Address Creation" },
  ];

  return (
    <ul className="items-center w-3/4 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg sm:flex dark:bg-gray-200 dark:border-gray-600 dark:text-white lg:ml-48 mt-10">
      {steps.map((step) => {
        const isActive = step.id === currentStep;
        const isCompleted = step.id < currentStep;
        const isPending = step.id > currentStep;

        // Circle styling
        let circleClass = "circle";
        if (isCompleted) {
          circleClass += " bg-green-500 text-white";
        } else if (isActive) {
          circleClass += " bg-blue-600 text-white ring-4 ring-blue-200";
        } else {
          circleClass += " bg-gray-300 text-gray-600";
        }

        // Border styling (for list items)
        let liClass = "w-full border-b border-gray-200 sm:border-b-0 sm:border-r dark:border-gray-600";
        if (step.id === steps.length) {
          liClass = "w-full dark:border-gray-600";
        }

        return (
          <li key={step.id} className={liClass}>
            <div className="flex items-center ps-3">
              <div className={circleClass}>
                {isCompleted ? (
                  <svg
                    className="w-4 h-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  step.id
                )}
              </div>
              <label
                htmlFor={`step-${step.id}`}
                className={`w-full py-3 ms-2 text-md font-semibold ${
                  isActive
                    ? "text-blue-700 dark:text-blue-500"
                    : isCompleted
                    ? "text-green-700 dark:text-green-500"
                    : "text-gray-900 dark:text-gray-800"
                }`}
              >
                {step.label}
              </label>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default Header;